import { supabase } from '../config/supabaseConfig.ts';

const today = () => new Date().toISOString().slice(0, 10);
const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
};

export const dashboardService = {
  getStats: async () => {
    const [
      { count: totalClients },
      { data: projects },
      { data: blocked },
      { data: todayUsage },
      { data: overLimit },
    ] = await Promise.all([
      supabase.from('clientes_usuario').select('id', { count: 'exact', head: true }),
      supabase.from('project').select('id, status'),
      supabase.from('user_effective_limits').select('user_id').eq('is_blocked', true),
      supabase.from('usage_daily').select('text_count, voice_count').eq('date', today()),
      supabase.from('user_effective_limits').select('user_id, email, text_used, text_limit, voice_used, voice_limit')
        .or('text_used.gte.text_limit,voice_used.gte.voice_limit'),
    ]);

    const activeProjects   = (projects || []).filter(p => p.status === 'active' || !p.status).length;
    const inactiveProjects = (projects || []).filter(p => p.status === 'inactive').length;
    const blockedCount    = (blocked || []).length;
    const msgToday = (todayUsage || []).reduce(
      (acc, r) => ({ text: acc.text + (r.text_count || 0), voice: acc.voice + (r.voice_count || 0) }), { text: 0, voice: 0 }
    );

    return {
      totalClients: totalClients || 0,
      activeProjects,
      inactiveProjects,
      blockedCount,
      msgToday,
      overLimit: (overLimit || []).filter(u => u.text_limit > 0 || u.voice_limit > 0),
    };
  },

  getUsageLast30Days: async () => {
    const { data } = await supabase
      .from('usage_daily')
      .select('date, text_count, voice_count')
      .gte('date', daysAgo(29))
      .order('date', { ascending: true });

    if (!data) return [];

    const grouped = {};
    data.forEach(r => {
      if (!grouped[r.date]) grouped[r.date] = { date: r.date, text: 0, voice: 0 };
      grouped[r.date].text  += r.text_count  || 0;
      grouped[r.date].voice += r.voice_count || 0;
    });

    const last30 = [];
    for (let i = 29; i >= 0; i--) {
      const d = daysAgo(i);
      last30.push(grouped[d] || { date: d, text: 0, voice: 0 });
    }
    return last30;
  },

  getTicketStats: async () => {
    const { data } = await supabase.from('ticket').select('status, created_at');
    if (!data) return { open: 0, closed: 0, inProgress: 0 };
    return {
      open:       data.filter(t => t.status === 'open').length,
      closed:     data.filter(t => t.status === 'closed').length,
      inProgress: data.filter(t => t.status === 'in_progress').length,
    };
  },

  getAdminLog: async () => {
    const { data } = await supabase
      .from('admin_log')
      .select('id, action, target_email, created_at, performed_by_email, metadata')
      .order('created_at', { ascending: false })
      .limit(10);
    return data || [];
  },
};
